import React, { useState } from "react";
import { Button, TextField, Box, MenuItem } from '@material-ui/core';
import CreateRoundUtil from "../CreateRound/CreateRoundUtil";
import { Team } from "../TeamOverview/TeamOverviewModels";
import ChooseTeamDialog from "./ChooseTeamDialog";
import { LeagueListItem } from "../CreateRound/CreateRoundModels";

interface TeamInputProps {
    label : string;
    team? : Team;
    disabled?: boolean;
    league?: LeagueListItem;
    minWidth?: number;
    onChange: (team: Team | undefined) => void;
}
// interface TeamInputState {
//     team?: Team;
// }


const TeamInput: React.FC<TeamInputProps> = (props) => {
    // const getDefaultFormState = () : TeamInputState => {
    //     return {
    //         team: props.team
    //     };
    // }
    
    //const [formState, setFormState] = useState<TeamInputState>(getDefaultFormState());
 
    const onCloseTeamDlg = (team?: Team) => {
        if (!team) {
            return;
        }
        // var fs = {...formState, ["team"]: team};
        // setFormState(fs);
        props.onChange(team);
    };

    var chooseTeamDlg = null;
    if (props.disabled === undefined || props.disabled === false) {
        chooseTeamDlg = (<ChooseTeamDialog open={false} openLabel="Change" league={props.league} onClose={onCloseTeamDlg} />);
    }
    var minWidth = props.minWidth !== undefined ? props.minWidth : 350;
 
    return (
        <Box paddingTop={1} display="flex" alignItems="center">
            <TextField
                margin="dense"
                name="teamName"
                value={props.team ? props.team.name : ""}
                label={props.label && props.label.length > 0 ? props.label : "Team"}
                helperText={props.team ? `id:${props.team.id}; providerId:${props.team.providerId}` : "Required"}
                error={!props.team}
                InputProps={{ readOnly: true }}
                style={{minWidth:minWidth}}
            />
            <span style={{ padding: 2 }}></span>
            {chooseTeamDlg}
        </Box>
    );
};

export default TeamInput;
